<template v-bind:is="currentTabComponent" >

    <spinner v-if="!loaded" ></spinner>

    <div class="page mt-3" v-else-if="loaded" >
        
        <b-input-group>
            <b-form-input v-model="filter" placeholder="Search by email, name or phone" class="search-input atlass-input-borderless" />
            <font-awesome-icon icon="times-circle" @click="filter = ''" class="reset-filter" v-bind:class="{ 'd-none' : !filter }" >Clear</font-awesome-icon>
        </b-input-group>
        
        <vue-good-table
            class=""
            :columns="columnns"
            :rows="data"
            styleClass="vgt-table atlass-datatable mt-4"
            :search-options="{ enabled: true, externalQuery: filter }"
            :pagination-options="{ 
                enabled: true,
                perPage: 20,
                perPageDropdown: [50, 100],
                ropdownAllowAll: true,
                nextLabel: 'next',
                prevLabel: 'prev',
                rowsPerPageLabel: 'Leads per page',
                ofLabel: 'of',
                pageLabel: 'page', // for 'pages' mode
                allLabel: 'All',
            }"
            :selectOptions="{
                enabled: false,
                selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
              }"
            @on-row-click="routeUser"
             >
            
                <template slot="table-row" slot-scope="props">
                    
                    <span v-if="props.column.field == 'previousURL' || props.column.field == 'referralURL'">

                        <span v-if="props.column.field == 'previousURL' " :id="`tooltip--${props.column.field}--${props.row.leadID}`" > {{ returnShortString( props.row.previousURL, 'previousURL' ) }} </span>

                        <span v-else-if="props.column.field == 'referralURL' " :id="`tooltip--${props.column.field}--${props.row.leadID}`" > {{ returnShortString( props.row.referralURL, 'referralURL' ) }} </span>

                        <b-tooltip :target="`tooltip--${props.column.field}--${props.row.leadID}`" placement="bottom" triggers="hover"  >
                            <span v-if="props.column.field == 'previousURL' "  > 
                                {{ props.row.previousURL }} 
                            </span>
                            <span v-else-if="props.column.field == 'referralURL' "  >
                                {{ props.row.referralURL }}
                            </span> 
                        </b-tooltip>
                        
                    </span>
                                        
                </template>
            
        </vue-good-table>
        
        <modal :modalData="modalData" :modalState="modalState" modalComponent="orders" ></modal>
        
    </div> <!-- .page -->

</template>

<script>
//import modal from '@/components/modal.vue'    

import firebase from "firebase";
import Cookies from 'js-cookie'
import moment from 'moment'  

import helper from '@/helpers/helpers.js';    
    
export default {
    name: 'orders',
    components:{
        modal: () => import('@/components/modal.vue')
    },
    props: {
        data: { 
            type: [Array],
        }
    },
    data: function(){
        return {
            filter: '',
            loaded: false,
            modalState : false,
            modalData: null,
            columnns:[
                {
                    label: 'NAME',
                    field: 'name',
                    //field: this.returnName,
                    tdClass: 'font-weight-bold',
                },
                
                {
                    label: 'TAG',
                    field: "tag",
                    //field: this.returnName,
                    hidden: true,
                },
                {
                    label: 'REVENUE',
                    field: 'revenue',
                    //field: this.return_revenue_column,
                    field: function(item){
                        let revenue = 0
                        item.conversions.forEach((c)=>{ 
                            if( c.status != 'failed' && c.status != 'refunded' ){
                                revenue += parseFloat(c.price)
                            }
                        })
                        return revenue
                    },
                    //formatFn: this.return_price_column,
                    type: 'number',
                    tdClass: 'font-weight-bold',
                    width: '100px'
                },
                {
                    label: 'CONVERSIONS',
                    //field: 'revenue'
                    field: function(item){
                        return item.conversions.length
                    },
                    //field: 'conversions',
                    type: 'number',
                    tdClass: 'font-weight-bold',
                },
                
            ],
        }
    },
    beforeCreate: function () {
    },
    created: function () {
        
    },
    mounted: function () {
        //console.log("Tags component")
        this.loaded = true;
    },
    beforeDestroy() {
    },
    methods: {
        returnDate(a){
            //let timezone = helper.getAccountTimezone()   
            //return this.$moment.unix(a.datetime).tz(timezone).format( 'MMM D, HH:mm:ss' )
            return helper.formatDate( a.datetime )
        },
        renderTag(field){
            return field.tag
        },
        returnShortString(link, type){
            let limit = 65
            if( link != null ){
                if( link.length > limit ){
                    return link.substring(0,limit) + "..."
                }else{
                    return link
                }
            }else{
                return ''
            }
            
        },
        routeUser(params){
            //console.log(params)
            let data = params.row.conversions
            this.fModalOpen( 'orders', data );
        },
        fModalOpen( target, data ){
            if( target == 'source' ){
                this.selectedSource = data.orders
            }else{
                this.modalData = data
            }
            this.modalState = true
        },
    },
    computed: {
        matches() {
                        
            return this.filter
                ? this.data.filter(row => {
                  let match = false
                  for (let key in row) {
                    //console.log(campaign['name']);
                    if (row['name'].toLowerCase().includes(this.filter.toLowerCase())) {
                      return true
                    }
                  }
                })
                : this.data
        }
    },
    watch: {
        data: function(){
            //console.log(this.data[0].tag)
            if( this.data[0].tag == undefined ){
                this.columnns[1].hidden = true
            }else{
                this.columnns[1].hidden = false
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped >


    .field{
        margin: 5px 0;
    }
    
    .span-width{
        min-width: 180px;
        max-width: 240px;
        display: inline-block;

    }
    
</style>



// WEBPACK FOOTER //
// src/components/orders-sources.vue